import React from 'react';
import {Link} from 'react-router-dom'
import { Grid, Row, Col } from 'react-flexbox-grid';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';
import UserListFilter from '../userList/UserListFilter';
import MenuPage from '../../pages/MenuPage';
import Pager from '../pagination/Pager.js';

import './UserList.css';

const UserList = ({ paging, users, openUser, onCreateUserClick, fetchUsers, searchKey}) => {

    return (
        <MenuPage title="Users" onBackClick={()=>{alert("Klick")}}>

            <div className="ButtonWrapper">
                <RaisedButton type="button" label="New User"
                              fullWidth={false}
                              onTouchTap={onCreateUserClick} />
            </div>

            <Grid fluid className="noXsPadding">
                <Row>
                    <Col xs={12}>
                        <UserListFilter fetchFilteredUsers={fetchUsers} searchKey={searchKey}/>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <Table selectable={false} onCellClick={(rowNumber) => openUser(rowNumber)}>
                            <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
                                <TableRow>
                                    <TableHeaderColumn>ID</TableHeaderColumn>
                                    <TableHeaderColumn>Username</TableHeaderColumn>
                                    <TableHeaderColumn>Displayname</TableHeaderColumn>
                                    <TableHeaderColumn>Language</TableHeaderColumn>
                                    <TableHeaderColumn>Enabled</TableHeaderColumn>
                                </TableRow>
                            </TableHeader>
                            <TableBody displayRowCheckbox={false} showRowHover={true}>
                                {users.map(user =>
                                    <TableRow key={user.id}>
                                        <TableRowColumn>{user.id}</TableRowColumn>
                                        <TableRowColumn>
                                            <Link to={`/users/${user.id}`}>{user.username}</Link>
                                        </TableRowColumn>
                                        <TableRowColumn>{user.displayName}</TableRowColumn>
                                        <TableRowColumn>{user.language}</TableRowColumn>
                                        <TableRowColumn>{user.enabled===true?'Yes':'No'}</TableRowColumn>
                                    </TableRow>
                                )
                                }
                            </TableBody>
                        </Table>
                    </Col>
                </Row>
                <Row>
                    <Pager currentPage={paging.number} totalPages={paging.totalPages} fetchUsers={fetchUsers} searchKey={searchKey} />
                </Row>

            </Grid>


        </MenuPage>
    )
}

export default UserList;


// WEBPACK FOOTER //
// ./src/components/userList/UserList.js